export interface AgeResult {
  year: number;
  month: number; // 1-based (1 = January ... 12 = December)
}

/**
 * Calculate the target year and month when a person reaches a specific age.
 *
 * The calculation assumes:
 * - `birthMonth` is 1-based (January = 1, December = 12)
 * - `ageMonths` is 0-based (0 = full years)
 * - The returned month is **adjusted to the next month**, because e.g.
 *   for retirement you cannot start mid-month.
 *
 * @param birthYear - Birth year (e.g., 1961)
 * @param birthMonth - Birth month, 1-based (1 = January)
 * @param ageYears - Age in years (e.g., 64)
 * @param ageMonths - Additional months, 0-based (0 = full years)
 * @returns AgeResult
 */
export const calculateTargetDateForNextMonth = (
  birthYear: number,
  birthMonth: number,
  ageYears: number,
  ageMonths: number,
): AgeResult => {
  // Add years and months
  let year = birthYear + ageYears;
  let month = birthMonth + ageMonths + 1; // +1 = move to next month for retirement adjustment

  // Handle month overflow
  if (month > 12) {
    year += 1;
    month = ((birthMonth + ageMonths) % 12) + 1;
  }

  return { year, month };
};
